export default {
  'pages.layouts.userLayout.title':
    'AimerPay - Adyen Balance Platform Management',

  // Login
  'pages.login.welcome': 'Welcome back',
  'pages.login.subtitle': 'Sign in to your merchant account',
  'pages.login.brandDescription':
    'Professional payment platform for merchants across Australia & New Zealand',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username or password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.userName.placeholder': 'Username or Email',
  'pages.login.userName.required': 'Please enter your username or email',
  'pages.login.email.placeholder': 'Email address',
  'pages.login.email.required': 'Please enter your email address',
  'pages.login.email.invalid': 'Please enter a valid email address',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter your password',
  'pages.login.forgotPassword': 'Forgot password?',
  'pages.login.forgotPassword.title': 'Reset Password',
  'pages.login.forgotPassword.description':
    'Enter your email address and we will send you a link to reset your password.',
  'pages.login.forgotPassword.emailPlaceholder': 'Enter your email address',
  'pages.login.forgotPassword.emailRequired': 'Please enter your email',
  'pages.login.forgotPassword.emailInvalid':
    'Please enter a valid email address',
  'pages.login.forgotPassword.submit': 'Send Reset Link',
  'pages.login.forgotPassword.success':
    'If an account exists with this email, a password reset link will be sent.',
  'pages.login.forgotPassword.error':
    'Failed to send reset email. Please try again.',
  'pages.login.submit': 'Sign In',
  'pages.login.noAccount': "Don't have an account?",
  'pages.login.contactAdmin': 'Contact your administrator',
  'pages.login.sessionExpired':
    'Your session has expired. Please sign in again.',

  // 403
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.403.buttonText': 'Back to Home',

  // 404
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back to Home',

  // Dashboard
  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.totalBalance': 'Total Balance',
  'pages.dashboard.accountHolders': 'Account Holders',
  'pages.dashboard.currentMerchant': 'Current Merchant',
  'pages.dashboard.pendingTransfers': 'Pending Transfers',
  'pages.dashboard.todayTransactions': "Today's Transactions",
  'pages.dashboard.recentTransactions': 'Recent Transactions',
  'pages.dashboard.recentTransactionsCount': 'Transactions',
  'pages.dashboard.inLast7Days': 'recent',
  'pages.dashboard.balanceOverview': 'Balance Overview',
  'pages.dashboard.quickActions': 'Quick Actions',
  'pages.dashboard.viewAll': 'View All',
  'pages.dashboard.noBalanceAccounts': 'No balance accounts yet',
  'pages.dashboard.noTransactions': 'No recent transactions',
  'pages.dashboard.moreAccounts': 'more accounts',
  'pages.dashboard.column.type': 'Type',

  // Partners (Business API)
  'pages.partners.title': 'Customers',
  'pages.partners.emptySubtitle': 'Manage your merchant accounts',
  'pages.partners.id': 'Customer ID',
  'pages.partners.name': 'Name',
  'pages.partners.legalEntity': 'Legal Entity',
  'pages.partners.status': 'Status',
  'pages.partners.capabilities': 'Capabilities',
  'pages.partners.createdAt': 'Created At',
  'pages.partners.actions': 'Actions',
  'pages.partners.enterWorkspace': 'Enter',
  'pages.partners.edit': 'Edit',
  'pages.partners.onboard': 'Onboard',
  'pages.partners.create': 'Create Customer',
  'pages.partners.create.success': 'Customer created successfully',
  'pages.partners.create.error': 'Failed to create customer',
  'pages.partners.create.button.withProfile': 'Create Customer · {profile}',
  'pages.partners.create.confirm.title':
    'Confirm creating a {profile} customer?',
  'pages.partners.create.confirm.title.default': 'Confirm creating a customer?',
  'pages.partners.create.confirm.content':
    'This cannot be changed after creation. Please confirm before continuing.',
  'pages.partners.create.confirm.ok': 'Confirm',
  'pages.partners.create.cancel': 'Cancel',
  'pages.partners.create.profileLocked':
    'Creating a {profile} ({merchantAccount}) customer. This account type is locked and cannot be changed after creation.',
  'pages.partners.editTitle': 'Edit Customer',
  'pages.partners.editSuccess': 'Customer updated successfully',
  'pages.partners.editError': 'Failed to update customer',
  'pages.partners.edit.addressLocked':
    'The Adyen legal entity already exists, so the legal name and address can no longer be changed here — update them through Adyen onboarding.',
  'pages.partners.column.type': 'Type',
  'pages.partners.column.email': 'Email',
  'pages.partners.column.adyenStatus': 'Adyen Status',
  'pages.partners.column.balanceAccounts': 'Balance Accounts',
  'pages.partners.column.adyenProfile': 'Adyen Profile',
  'pages.partners.status.Draft': 'Draft',
  'pages.partners.status.Pending': 'Pending',
  'pages.partners.status.Active': 'Active',
  'pages.partners.status.Suspended': 'Suspended',
  'pages.partners.status.Rejected': 'Rejected',
  // Admin partner access request workflow
  'pages.partners.access.column': 'Access',
  'pages.partners.access.expiresAt': 'Expires At',
  'pages.partners.access.none': 'Not Requested',
  'pages.partners.access.pending': 'Pending Approval',
  'pages.partners.access.active': 'Granted',
  'pages.partners.access.expired': 'Expired',
  'pages.partners.access.rejected': 'Rejected',
  'pages.partners.access.enter': 'Enter',
  'pages.partners.access.request': 'Request',
  'pages.partners.access.cancel': 'Cancel Request',
  'pages.partners.access.cancelConfirm': 'Cancel this access request?',
  'pages.partners.access.requestSuccess': 'Access request submitted',
  'pages.partners.access.cancelSuccess': 'Request cancelled',
  // Partner Form
  'pages.partners.form.type': 'Type',
  'pages.partners.form.type.placeholder': 'Select customer type',
  'pages.partners.form.type.required': 'Please select type',
  'pages.partners.form.type.organization': 'Organization',
  'pages.partners.form.type.individual': 'Individual',
  'pages.partners.type.org.short': 'Org',
  'pages.partners.type.ind.short': 'Ind',
  'pages.partners.form.firstName': 'First Name',
  'pages.partners.form.firstName.placeholder': 'Enter first name',
  'pages.partners.form.firstName.required':
    'First name is required for individuals',
  'pages.partners.form.lastName': 'Last Name',
  'pages.partners.form.lastName.placeholder': 'Enter last name',
  'pages.partners.form.lastName.required':
    'Last name is required for individuals',
  'pages.partners.form.street': 'Street',
  'pages.partners.form.street.placeholder': 'Enter street address',
  'pages.partners.form.street.required': 'Street address is required',
  'pages.partners.form.street.invalidChars':
    'Address cannot contain Chinese characters or full-width punctuation. Please use English half-width characters.',
  'pages.partners.form.city': 'City',
  'pages.partners.form.city.placeholder': 'Enter city',
  'pages.partners.form.city.select.placeholder': 'Select city',
  'pages.partners.form.city.required': 'City is required',
  'pages.partners.form.postalCode': 'Postal Code',
  'pages.partners.form.postalCode.placeholder': 'Enter postal code',
  'pages.partners.form.postalCode.required': 'Postal code is required',
  'pages.partners.form.postalCode.formatInvalid':
    'Postal code must be 4 digits',
  'pages.partners.form.stateOrProvince': 'State/Province',
  'pages.partners.form.stateOrProvince.placeholder':
    'Enter state or province (optional)',
  'pages.partners.form.stateOrProvince.autoFilled': 'Auto-filled',
  'pages.partners.form.partnerName': 'Customer Name',
  'pages.partners.form.partnerName.placeholder': 'Enter customer name',
  'pages.partners.form.partnerName.required': 'Please enter customer name',
  'pages.partners.form.legalName': 'Legal Business Name',
  'pages.partners.form.legalName.placeholder': 'Enter legal business name',
  'pages.partners.form.legalName.required': 'Please enter legal name',
  'pages.partners.form.reference': 'Reference',
  'pages.partners.form.reference.tooltip':
    'Unique identifier for this merchant (e.g., merchant-123)',
  'pages.partners.form.reference.placeholder':
    'Enter unique reference (optional)',
  'pages.partners.form.reference.pattern':
    'Only letters, numbers, hyphens and underscores allowed',
  'pages.partners.form.country': 'Country',
  'pages.partners.form.country.placeholder': 'Select country',
  'pages.partners.form.country.required': 'Please select country',
  'pages.partners.form.country.AU': 'Australia',
  'pages.partners.form.country.NZ': 'New Zealand',
  'pages.partners.form.adyenProfile': 'Adyen Profile',
  'pages.partners.form.adyenProfile.tooltip':
    'Which Adyen merchant account this merchant is onboarded onto, and therefore its default commission split configuration. Fixed once the merchant has a store.',
  'pages.partners.form.adyenProfile.placeholder': 'Use the default profile',
  'pages.partners.form.adyenProfile.editHint':
    'Can only be changed while this merchant has no stores.',
  'pages.partners.form.adyenProfile.hasStores':
    'This merchant already has stores, so its Adyen profile can no longer be changed.',
  'pages.partners.form.businessType': 'Business Type',
  'pages.partners.form.businessType.placeholder': 'Select business type',
  'pages.partners.form.businessType.required':
    'Please select your business type',
  'pages.partners.form.businessType.restaurant': 'Restaurant (Dine-in)',
  'pages.partners.form.businessType.fastFood': 'Fast Food / Takeaway',
  'pages.partners.form.businessType.cafe': 'Cafe / Bubble Tea',
  'pages.partners.form.businessType.bar': 'Bar / Pub',
  'pages.partners.form.businessType.supermarket': 'Supermarket / Grocery',
  'pages.partners.form.businessType.specialtyFood': 'Specialty Food Store',
  'pages.partners.form.businessType.laundry': 'Laundry & Drycleaning (General)',
  'pages.partners.form.businessType.laundromat': 'Laundromat (Self-service)',
  'pages.partners.form.businessType.dryCleaner': 'Dry Cleaner',
  'pages.partners.form.salesChannels': 'Sales Channel',
  'pages.partners.form.salesChannels.required': 'Please select a sales channel',
  'pages.partners.form.salesChannels.pos': 'POS',
  'pages.partners.form.salesChannels.pos.desc':
    'For in-store sales and payments using POS terminals',
  'pages.partners.form.salesChannels.ecommerce': 'eCommerce',
  'pages.partners.form.salesChannels.ecommerce.desc':
    'For online sales through your website or app',
  'pages.partners.form.websiteUrl': 'Website URL',
  'pages.partners.form.websiteUrl.placeholder': 'https://your-website.com',
  'pages.partners.form.websiteUrl.hint':
    'Required for E-commerce channel. Multiple URLs separated by comma.',
  'pages.partners.form.websiteUrl.required':
    'Website URL is required when E-commerce is selected',
  'pages.partners.form.websiteUrl.invalid':
    'Please enter a valid URL (starting with http:// or https://)',
  'pages.partners.form.email': 'Email',
  'pages.partners.form.email.placeholder': 'Enter contact email',
  'pages.partners.form.email.required': 'Please enter email',
  'pages.partners.form.email.invalid': 'Please enter valid email',
  'pages.partners.form.paymentMethods': 'Payment Methods',
  'pages.partners.form.paymentMethods.required':
    'Please select at least one payment method',
  'pages.partners.form.paymentMethods.visa': 'Visa',
  'pages.partners.form.paymentMethods.mc': 'Mastercard',
  'pages.partners.form.paymentMethods.amex': 'American Express',
  'pages.partners.form.description': 'Description',
  'pages.partners.form.description.placeholder': 'Enter description (optional)',

  // Account Holders (Legacy - keep for backward compatibility)
  'pages.accountHolders.title': 'Customers',
  'pages.accountHolders.emptySubtitle': 'Manage your merchant accounts',
  'pages.accountHolders.id': 'Customer ID',
  'pages.accountHolders.name': 'Name',
  'pages.accountHolders.legalEntity': 'Legal Entity',
  'pages.accountHolders.status': 'Status',
  'pages.accountHolders.capabilities': 'Capabilities',
  'pages.accountHolders.createdAt': 'Created At',
  'pages.accountHolders.actions': 'Actions',
  'pages.accountHolders.view': 'View',
  'pages.accountHolders.edit': 'Edit',
  'pages.accountHolders.onboard': 'Onboard',
  'pages.accountHolders.create': 'Create Customer',
  'pages.accountHolders.create.success': 'Customer created successfully',
  'pages.accountHolders.status.active': 'Active',
  'pages.accountHolders.status.inactive': 'Inactive',
  'pages.accountHolders.status.suspended': 'Suspended',
  'pages.accountHolders.status.closed': 'Closed',
  // Create Account Holder Form (Legacy)
  'pages.accountHolders.form.partnerName': 'Customer Name',
  'pages.accountHolders.form.partnerName.placeholder': 'Enter customer name',
  'pages.accountHolders.form.partnerName.required':
    'Please enter customer name',
  'pages.accountHolders.form.legalName': 'Legal Business Name',
  'pages.accountHolders.form.legalName.placeholder':
    'Enter legal business name',
  'pages.accountHolders.form.legalName.required': 'Please enter legal name',
  'pages.accountHolders.form.reference': 'Reference',
  'pages.accountHolders.form.reference.tooltip':
    'Unique identifier for this merchant (e.g., merchant-123)',
  'pages.accountHolders.form.reference.placeholder':
    'Enter unique reference (optional)',
  'pages.accountHolders.form.reference.pattern':
    'Only letters, numbers, hyphens and underscores allowed',
  'pages.accountHolders.form.country': 'Country',
  'pages.accountHolders.form.country.placeholder': 'Select country',
  'pages.accountHolders.form.country.required': 'Please select country',
  'pages.accountHolders.form.country.AU': 'Australia',
  'pages.accountHolders.form.country.NZ': 'New Zealand',
  'pages.accountHolders.form.businessType': 'Business Type',
  'pages.accountHolders.form.businessType.placeholder': 'Select business type',
  'pages.accountHolders.form.businessType.retail': 'Retail',
  'pages.accountHolders.form.businessType.food_beverage': 'Food & Beverage',
  'pages.accountHolders.form.businessType.professional_services':
    'Professional Services',
  'pages.accountHolders.form.businessType.ecommerce': 'E-commerce',
  'pages.accountHolders.form.businessType.other': 'Other',
  'pages.accountHolders.form.email': 'Email',
  'pages.accountHolders.form.email.placeholder': 'Enter contact email',
  'pages.accountHolders.form.email.required': 'Please enter email',
  'pages.accountHolders.form.email.invalid': 'Please enter valid email',
  'pages.accountHolders.form.description': 'Description',
  'pages.accountHolders.form.description.placeholder':
    'Enter description (optional)',

  // Balance Accounts
  'pages.balanceAccounts.title': 'Balance Accounts',
  'pages.balanceAccounts.id': 'Account ID',
  'pages.balanceAccounts.accountHolder': 'Account Holder',
  'pages.balanceAccounts.description': 'Description',
  'pages.balanceAccounts.balance': 'Balance',
  'pages.balanceAccounts.balance.pending': 'Pending',
  'pages.balanceAccounts.currency': 'Currency',
  'pages.balanceAccounts.currency.selectPlaceholder': 'Select currency',
  'pages.balanceAccounts.currency.selectRequired': 'Please select currency',
  'pages.balanceAccounts.timeZone': 'Time Zone',
  'pages.balanceAccounts.timeZone.selectPlaceholder': 'Select time zone',
  'pages.balanceAccounts.timeZone.required': 'Please select time zone',
  'pages.balanceAccounts.partner': 'Customer',
  'pages.balanceAccounts.balance.available': 'Available',
  'pages.balanceAccounts.notFound': 'Balance Account Not Found',
  'pages.balanceAccounts.notFoundDesc':
    "Balance account with ID {id} does not exist or you don't have access to it.",
  'pages.balanceAccounts.status': 'Status',
  'pages.balanceAccounts.status.active': 'Active',
  'pages.balanceAccounts.status.inactive': 'Inactive',
  'pages.balanceAccounts.createdAt': 'Created At',
  'pages.balanceAccounts.actions': 'Actions',
  'pages.balanceAccounts.view': 'View',
  'pages.balanceAccounts.manage': 'Manage',
  'pages.balanceAccounts.create': 'Create Balance Account',
  'pages.balanceAccounts.create.success':
    'Balance account created successfully',
  'pages.balanceAccounts.edit': 'Edit Balance Account',
  'pages.balanceAccounts.edit.success': 'Balance account updated successfully',
  'pages.balanceAccounts.status.suspended': 'Suspended',
  'pages.balanceAccounts.status.selectPlaceholder': 'Select status',
  'pages.balanceAccounts.empty':
    'No balance accounts found. Complete onboarding to create balance accounts.',

  // Transactions
  'pages.transactions.title': 'Transactions',
  'pages.transactions.selectAccount': 'Select Balance Account',
  'pages.transactions.noAccount': 'Please select a balance account first',
  'pages.transactions.noBalanceAccounts':
    'No balance accounts available. Please create a balance account first.',
  'pages.transactions.amount': 'Amount',
  'pages.transactions.status': 'Status',
  'pages.transactions.createdAt': 'Created At',

  // Payouts
  'pages.payouts.title': 'Payouts',
  'pages.payouts.selectAccount': 'Select Balance Account',
  'pages.payouts.noAccount': 'Please select a balance account first',
  'pages.payouts.noBalanceAccounts':
    'No balance accounts available. Please create a balance account first.',

  // Onboarding
  'pages.onboarding.title': 'Merchant Onboarding',
  'pages.onboarding.description':
    'Complete merchant onboarding through Adyen Hosted Onboarding',
  'pages.onboarding.startOnboarding': 'Start Onboarding',
  'pages.onboarding.continue': 'Continue Onboarding',
  'pages.onboarding.status': 'Onboarding Status',
  'pages.onboarding.pending': 'Pending',
  'pages.onboarding.inProgress': 'In Progress',
  'pages.onboarding.completed': 'Completed',
  'pages.onboarding.rejected': 'Rejected',
  'pages.onboarding.createMerchant.title': 'Create New Merchant',
  'pages.onboarding.createMerchant.description':
    'Start the onboarding process to add a new merchant to your account. You will need to provide business information and complete KYC verification through Adyen.',
  'pages.onboarding.createMerchant.button': 'Add New Merchant',
  'pages.onboarding.merchantList.title': 'Your Merchants',
  'pages.onboarding.noMerchants':
    'No merchants yet. Create your first merchant to get started.',
  'pages.onboarding.createFirst': 'Create First Merchant',
  'pages.onboarding.viewDetails': 'View Details',
  'pages.onboarding.linkOpened': 'Onboarding page opened in new tab',
  'pages.onboarding.linkError': 'Failed to get onboarding link',
  'pages.onboarding.createInfo':
    'Creating new merchant requires backend integration with Adyen',
  'pages.onboarding.refreshed': 'Merchant list refreshed',
  'pages.onboarding.status.pending': 'Pending',
  'pages.onboarding.status.inProgress': 'In Progress',
  'pages.onboarding.status.completed': 'Completed',
  'pages.onboarding.status.rejected': 'Rejected',
  // Onboarding Callback
  'pages.onboarding.callback.processing': 'Processing onboarding results...',
  'pages.onboarding.callback.processingDesc':
    'Please wait while we update your account information. This may take a few moments.',
  'pages.onboarding.callback.success': 'Onboarding Completed Successfully!',
  'pages.onboarding.callback.successDesc':
    'Your KYC information has been submitted. Adyen will review your information and notify you once verification is complete.',
  'pages.onboarding.callback.successRedirect':
    'You will be redirected to your account holder page shortly.',
  'pages.onboarding.callback.failed': 'Onboarding Failed',
  'pages.onboarding.callback.failedDesc':
    'There was an error processing your onboarding. Please try again or contact support.',
  'pages.onboarding.callback.returnMerchants': 'Return to Merchants',

  // Setup Adyen
  'pages.partners.setupAdyen': 'Setup Adyen',
  'pages.partners.setupAdyen.title': 'Configure Adyen Integration',
  'pages.partners.setupAdyen.success': 'Adyen setup completed successfully',
  'pages.partners.setupAdyen.error': 'Failed to setup Adyen integration',
  'pages.partners.startKyc': 'Start KYC',

  // Reports
  'pages.reports.title': 'Reports',
  'pages.reports.selectAccount': 'Select Balance Account',
  'pages.reports.noAccount': 'Please select a balance account first',
  'pages.reports.noBalanceAccounts':
    'No balance accounts available. Please create a balance account first.',

  // Disputes
  'pages.disputes.title': 'Disputes',
  'pages.disputes.selectAccount': 'Select Balance Account',
  'pages.disputes.noAccount': 'Please select a balance account first',
  'pages.disputes.noBalanceAccounts':
    'No balance accounts available. Please create a balance account first.',
  'pages.disputes.description':
    'View and manage chargebacks, fraud alerts, and submit defense documents.',

  // Stores
  'pages.stores.title': 'Stores',
  'pages.stores.id': 'Store ID',
  'pages.stores.reference': 'Store Reference',
  'pages.stores.reference.placeholder': 'Enter store reference',
  'pages.stores.reference.required': 'Please enter store reference',
  'pages.stores.reference.pattern':
    'Only letters, numbers, hyphens and underscores allowed',
  'pages.stores.reference.tooltip':
    'Unique identifier for this store (e.g., merchant-123-store-A)',
  'pages.stores.description': 'Description',
  'pages.stores.description.placeholder':
    'Enter store description (e.g., Sydney Flagship Store)',
  'pages.stores.description.required': 'Please enter store description',
  'pages.stores.shopperStatement': 'Shopper Statement',
  'pages.stores.shopperStatement.placeholder': 'Enter shopper statement',
  'pages.stores.shopperStatement.tooltip':
    'Text shown on customer bank statement (max 22 characters)',
  'pages.stores.status': 'Status',
  'pages.stores.status.active': 'Active',
  'pages.stores.status.inactive': 'Inactive',
  'pages.stores.status.closed': 'Closed',
  'pages.stores.status.Active': 'Active',
  'pages.stores.status.Pending': 'Pending',
  'pages.stores.status.Draft': 'Draft',
  'pages.stores.status.Suspended': 'Suspended',
  'pages.stores.status.Closed': 'Closed',
  'pages.stores.storeType': 'Store Type',
  'pages.stores.storeType.POS': 'POS',
  'pages.stores.storeType.ECommerce': 'eCommerce',
  'pages.stores.storeType.TapToPay': 'Tap to Pay',
  'pages.stores.storeType.Others': 'Others',
  'pages.stores.form.storeType': 'Store Type',
  'pages.stores.form.storeType.required': 'Please select a store type',
  'pages.stores.form.storeType.placeholder': 'Select store type',
  'pages.stores.adyenStoreId': 'Adyen Store ID',
  'pages.stores.storeAddress': 'Store Address',
  'pages.stores.splitConfigured': 'Split Configured',
  'pages.stores.splitConfigured.yes': 'Yes',
  'pages.stores.splitConfigured.no': 'No',
  'pages.stores.actions': 'Actions',
  'pages.stores.view': 'View',
  'pages.stores.edit': 'Edit',
  'pages.stores.delete': 'Delete',
  'pages.stores.create': 'Create Store',
  'pages.stores.createSuccess': 'Store created successfully',
  'pages.stores.createError': 'Failed to create store',
  'pages.stores.editTitle': 'Edit Store',
  'pages.stores.editSuccess': 'Store updated successfully',
  'pages.stores.editError': 'Failed to update store',
  'pages.store.businessLine': 'Business Line',
  'pages.stores.form.businessLine.required': 'Please select a business line',
  'pages.stores.form.businessLine.noMatch':
    'No business lines available for the selected store type. Please create a business line first.',
  'pages.stores.deleteConfirm': 'Are you sure you want to delete this store?',
  'pages.stores.deleteSuccess': 'Store deleted successfully',
  'pages.stores.deleteError': 'Failed to delete store',
  'pages.stores.detailTitle': 'Store Details',
  'pages.stores.noMerchantAccount':
    'No merchant account found. Please complete onboarding first.',
  'pages.stores.noStores':
    'No stores yet. Create your first store to start accepting payments.',
  'pages.stores.tip.provideReference':
    'Please share the Store Reference with your POS provider to enable them to complete the configuration and associate the store with their platform.',
  'pages.stores.createdAt': 'Created At',
  'pages.stores.merchantId': 'Merchant ID',
  // Store Form
  'pages.stores.form.creationTitle': 'Store Creation',
  'pages.stores.form.creationDesc':
    "Store reference will be auto-generated by the system. Payment splitting will be configured automatically based on the partner's settings.",
  'pages.stores.form.storeName': 'Store Name',
  'pages.stores.form.storeName.placeholder':
    'Enter store name (e.g., Sydney Flagship Store)',
  'pages.stores.form.storeName.required': 'Please enter store name',
  'pages.stores.form.storeName.maxLength': 'Maximum 15 characters',
  'pages.stores.form.description.optional': 'Description (Optional)',
  'pages.stores.form.description.optionalPlaceholder':
    'Enter store description (optional)',
  'pages.stores.form.phoneNumber': 'Phone Number',
  'pages.stores.form.phoneNumber.placeholder': 'Enter phone number digits',
  'pages.stores.form.phoneNumber.required': 'Phone number is required',
  'pages.stores.form.phoneNumber.formatInvalid': 'Invalid phone number format',
  'pages.stores.form.country': 'Country',
  'pages.stores.form.country.placeholder': 'Select country',
  'pages.stores.form.country.required': 'Please select country',
  'pages.stores.form.country.AU': 'Australia',
  'pages.stores.form.country.NZ': 'New Zealand',
  'pages.stores.form.line1': 'Address Line 1',
  'pages.stores.form.line1.placeholder': 'Enter street address',
  'pages.stores.form.line1.required': 'Please enter address line 1',
  'pages.stores.form.line2': 'Address Line 2',
  'pages.stores.form.line2.placeholder': 'Apartment, suite, floor (optional)',
  'pages.stores.form.line3': 'Address Line 3',
  'pages.stores.form.line3.placeholder':
    'Additional address details (optional)',
  'pages.stores.form.addressLine.invalidChars':
    'Address cannot contain Chinese characters or full-width punctuation. Please use English half-width characters.',
  'pages.stores.form.city': 'City',
  'pages.stores.form.city.required': 'Please select or enter city',
  'pages.stores.form.city.select.placeholder': 'Select city',
  'pages.stores.form.city.placeholder': 'Enter city',
  'pages.stores.form.postalCode': 'Postal Code',
  'pages.stores.form.postalCode.placeholder': 'Enter postal code',
  'pages.stores.form.postalCode.required': 'Please enter postal code',
  'pages.stores.form.stateOrProvince': 'State / Province',
  'pages.stores.form.stateOrProvince.placeholder': 'Enter state or province',
  'pages.stores.form.stateOrProvince.autoFilled': 'Auto-filled',
  'pages.stores.form.stateOrProvince.customHint':
    'Enter ISO code (e.g. NSW, AUK)',
  'pages.stores.form.balanceAccount': 'Balance Account',
  'pages.stores.form.balanceAccount.required':
    'Please select a balance account',
  'pages.stores.form.status': 'Status',

  // Register (Invitation)
  'pages.register.pageTitle': 'Register',
  'pages.register.title': 'Complete Your Registration',
  'pages.register.subtitle': 'Set up your account to get started',
  'pages.register.verifying': 'Verifying your invitation...',
  'pages.register.invalidLink': 'Invalid Invitation Link',
  'pages.register.invalidLinkDesc':
    'This invitation link is invalid or has already been used. Please contact your administrator for a new invitation.',
  'pages.register.expiredLink': 'Invitation Expired',
  'pages.register.expiredLinkDesc':
    'This invitation link has expired. Please contact your administrator for a new invitation.',
  'pages.register.usedLink': 'Invitation Already Used',
  'pages.register.usedLinkDesc':
    'This invitation link has already been used. If you have already registered, please sign in.',
  'pages.register.success': 'Registration Successful',
  'pages.register.successDesc':
    'Your account has been created successfully. You can now sign in with your email and password.',
  'pages.register.errorTitle': 'Registration Failed',
  'pages.register.error': 'Failed to complete registration. Please try again.',
  'pages.register.role': 'Role',
  'pages.register.organization': 'Organization',
  'pages.register.invitedBy': 'Invited by',
  'pages.register.userName': 'Username',
  'pages.register.userNameRequired': 'Please enter your username',
  'pages.register.userNameMinLength': 'Username must be at least 3 characters',
  'pages.register.userNamePattern':
    'Username can only contain letters, numbers and underscore',
  'pages.register.displayName': 'Display Name',
  'pages.register.displayNameRequired': 'Please enter your display name',
  'pages.register.displayNameMinLength':
    'Display name must be at least 2 characters',
  'pages.register.phone': 'Phone number',
  'pages.register.phoneRequired': 'Please enter your phone number',
  'pages.register.phonePattern': 'Please enter a valid phone number',
  'pages.register.password': 'Password',
  'pages.register.passwordRequired': 'Please enter your password',
  'pages.register.confirmPassword': 'Confirm password',
  'pages.register.confirmPasswordRequired': 'Please confirm your password',
  'pages.register.passwordMismatch': 'Passwords do not match',
  'pages.register.passwordMinLength': 'Password must be at least 8 characters',
  'pages.register.passwordComplexity':
    'Password must contain uppercase, lowercase and number',
  'pages.register.submit': 'Create Account',
  'pages.register.hasAccount': 'Already have an account?',
  'pages.register.signIn': 'Sign in',
  'pages.register.backToLogin': 'Back to Login',
  'pages.register.goToLogin': 'Go to Login',

  // Reset Password
  'pages.resetPassword.pageTitle': 'Reset Password',
  'pages.resetPassword.title': 'Reset Your Password',
  'pages.resetPassword.subtitle': 'Please enter your new password below',
  'pages.resetPassword.verifying': 'Verifying your reset link...',
  'pages.resetPassword.invalidLink': 'Invalid Reset Link',
  'pages.resetPassword.invalidLinkDesc':
    'This password reset link is invalid or has already been used. Please request a new one.',
  'pages.resetPassword.expiredLink': 'Link Expired',
  'pages.resetPassword.expiredLinkDesc':
    'This password reset link has expired. Please request a new password reset.',
  'pages.resetPassword.success': 'Password Reset Successful',
  'pages.resetPassword.successDesc':
    'Your password has been reset successfully. You can now sign in with your new password.',
  'pages.resetPassword.errorTitle': 'Reset Failed',
  'pages.resetPassword.error': 'Failed to reset password. Please try again.',
  'pages.resetPassword.newPassword': 'New password',
  'pages.resetPassword.newPasswordRequired': 'Please enter your new password',
  'pages.resetPassword.confirmPassword': 'Confirm new password',
  'pages.resetPassword.confirmPasswordRequired':
    'Please confirm your new password',
  'pages.resetPassword.passwordMismatch': 'Passwords do not match',
  'pages.resetPassword.passwordMinLength':
    'Password must be at least 8 characters',
  'pages.resetPassword.passwordComplexity':
    'Password must contain uppercase, lowercase and number',
  'pages.resetPassword.submit': 'Reset Password',
  'pages.resetPassword.backToLogin': 'Back to Login',
  'pages.resetPassword.goToLogin': 'Go to Login',

  // Accept Invitation
  'pages.acceptInvitation.pageTitle': 'Accept Invitation',
  'pages.acceptInvitation.title': 'Complete Your Registration',
  'pages.acceptInvitation.subtitle':
    "You've been invited to join AimerPay. Please set up your account.",
  'pages.acceptInvitation.verifying': 'Verifying your invitation...',
  'pages.acceptInvitation.invalidLink': 'Invalid Invitation Link',
  'pages.acceptInvitation.invalidLinkDesc':
    'This invitation link is invalid or has expired. Please contact your administrator.',
  'pages.acceptInvitation.expiredLink': 'Invitation Expired',
  'pages.acceptInvitation.expiredLinkDesc':
    'This invitation has expired. Please ask your administrator to send a new invitation.',
  'pages.acceptInvitation.usedLink': 'Invitation Already Used',
  'pages.acceptInvitation.usedLinkDesc':
    'This invitation has already been accepted. Please sign in with your account.',
  'pages.acceptInvitation.success': 'Registration Complete!',
  'pages.acceptInvitation.successDesc':
    'Your account has been set up successfully. Redirecting you now...',
  'pages.acceptInvitation.errorTitle': 'Registration Failed',
  'pages.acceptInvitation.error':
    'Failed to complete registration. Please try again.',
  'pages.acceptInvitation.field.email': 'Email',
  'pages.acceptInvitation.field.role': 'Role',
  'pages.acceptInvitation.field.userName': 'Username',
  'pages.acceptInvitation.field.userNameRequired': 'Please enter a username',
  'pages.acceptInvitation.field.userNameMinLength':
    'Username must be at least 3 characters',
  'pages.acceptInvitation.field.displayName': 'Full name',
  'pages.acceptInvitation.field.displayNameRequired':
    'Please enter your full name',
  'pages.acceptInvitation.field.phone': 'Phone number',
  'pages.acceptInvitation.field.phoneRequired':
    'Please enter your phone number',
  'pages.acceptInvitation.field.password': 'Password',
  'pages.acceptInvitation.field.passwordRequired': 'Please enter a password',
  'pages.acceptInvitation.field.passwordMinLength':
    'Password must be at least 8 characters',
  'pages.acceptInvitation.field.passwordComplexity':
    'Password must contain uppercase, lowercase and number',
  'pages.acceptInvitation.field.confirmPassword': 'Confirm password',
  'pages.acceptInvitation.field.confirmPasswordRequired':
    'Please confirm your password',
  'pages.acceptInvitation.field.passwordMismatch': 'Passwords do not match',
  'pages.acceptInvitation.submit': 'Complete Registration',
  'pages.acceptInvitation.backToLogin': 'Already have an account? Sign in',
  'pages.acceptInvitation.goToLogin': 'Go to Login',
  'pages.acceptInvitation.goToDashboard': 'Go to Dashboard',

  // Personal Settings
  'pages.settings.title': 'Personal Settings',
  'pages.settings.profile.title': 'Profile Information',
  'pages.settings.profile.name': 'Name',
  'pages.settings.profile.nameRequired': 'Please enter your name',
  'pages.settings.profile.email': 'Email',
  'pages.settings.profile.emailInvalid': 'Please enter a valid email',
  'pages.settings.profile.phone': 'Phone',
  'pages.settings.profile.save': 'Save Changes',
  'pages.settings.profile.success': 'Profile updated successfully',
  'pages.settings.profile.error': 'Failed to update profile',
  'pages.settings.avatar.change': 'Change Avatar',
  'pages.settings.avatar.success': 'Avatar updated successfully',
  'pages.settings.security.title': 'Change Password',
  'pages.settings.password.current': 'Current Password',
  'pages.settings.password.currentRequired':
    'Please enter your current password',
  'pages.settings.password.currentPlaceholder': 'Enter current password',
  'pages.settings.password.new': 'New Password',
  'pages.settings.password.newRequired': 'Please enter your new password',
  'pages.settings.password.newPlaceholder': 'Enter new password',
  'pages.settings.password.confirm': 'Confirm New Password',
  'pages.settings.password.confirmRequired': 'Please confirm your new password',
  'pages.settings.password.confirmPlaceholder': 'Confirm new password',
  'pages.settings.password.minLength': 'Password must be at least 8 characters',
  'pages.settings.password.complexity':
    'Password must contain uppercase, lowercase and number',
  'pages.settings.password.mismatch': 'Passwords do not match',
  'pages.settings.password.submit': 'Change Password',
  'pages.settings.password.success': 'Password changed successfully',
  'pages.settings.password.error': 'Failed to change password',
  'pages.settings.password.wrongCurrent': 'Current password is incorrect',
  // Staff Invitation
  'pages.settings.invite.title': 'Invite Staff',
  'pages.settings.invite.description':
    'Send an invitation email to add new staff members to your merchant account.',
  'pages.settings.invite.email': 'Email Address',
  'pages.settings.invite.emailPlaceholder': 'Enter staff email address',
  'pages.settings.invite.emailRequired': 'Please enter an email address',
  'pages.settings.invite.emailInvalid': 'Please enter a valid email address',
  'pages.settings.invite.role': 'Role',
  'pages.settings.invite.rolePlaceholder': 'Select a role',
  'pages.settings.invite.roleRequired': 'Please select a role',
  'pages.settings.invite.role.accountant': 'Accountant',
  'pages.settings.invite.role.accountantDesc':
    'View transactions, reports, and process refunds',
  'pages.settings.invite.role.viewer': 'Viewer',
  'pages.settings.invite.role.viewerDesc': 'View transactions only',
  'pages.settings.invite.submit': 'Send Invitation',
  'pages.settings.invite.success': 'Invitation sent to {email}',
  'pages.settings.invite.error': 'Failed to send invitation',

  // Staff Management
  'pages.staffManagement.title': 'Staff Management',
  'pages.staffManagement.noAccess':
    'You do not have permission to access this page.',
  'pages.staffManagement.invite.title': 'Invite Staff',
  'pages.staffManagement.invite.description':
    'Send an invitation email to add new staff members to your merchant account.',
  'pages.staffManagement.invite.email': 'Email Address',
  'pages.staffManagement.invite.emailPlaceholder': 'Enter staff email address',
  'pages.staffManagement.invite.emailRequired': 'Please enter an email address',
  'pages.staffManagement.invite.emailInvalid':
    'Please enter a valid email address',
  'pages.staffManagement.invite.role': 'Role',
  'pages.staffManagement.invite.rolePlaceholder': 'Select a role',
  'pages.staffManagement.invite.roleRequired': 'Please select a role',
  'pages.staffManagement.invite.role.accountant': 'Accountant',
  'pages.staffManagement.invite.role.accountantDesc':
    'View transactions, reports, and process refunds',
  'pages.staffManagement.invite.role.viewer': 'Viewer',
  'pages.staffManagement.invite.role.viewerDesc': 'View transactions only',
  'pages.staffManagement.invite.submit': 'Send Invitation',
  'pages.staffManagement.invite.success': 'Invitation sent to {email}',
  'pages.staffManagement.invite.error': 'Failed to send invitation',
  'pages.staffManagement.list.title': 'Staff List',
  'pages.staffManagement.table.name': 'Name',
  'pages.staffManagement.table.username': 'Username',
  'pages.staffManagement.table.email': 'Email',
  'pages.staffManagement.table.phone': 'Phone',
  'pages.staffManagement.table.role': 'Role',
  'pages.staffManagement.table.status': 'Status',
  'pages.staffManagement.table.invitedAt': 'Invited At',
  'pages.staffManagement.table.actions': 'Actions',
  'pages.staffManagement.role.accountant': 'Accountant',
  'pages.staffManagement.role.viewer': 'Viewer',
  'pages.staffManagement.status.active': 'Active',
  'pages.staffManagement.status.inactive': 'Inactive',
  'pages.staffManagement.status.activated': 'Staff activated successfully',
  'pages.staffManagement.status.deactivated': 'Staff deactivated successfully',
  'pages.staffManagement.status.error': 'Failed to update staff status',
  'pages.staffManagement.action.activate': 'Activate',
  'pages.staffManagement.action.deactivate': 'Deactivate',
  'pages.staffManagement.activate.confirm':
    'Are you sure you want to activate this staff member?',
  'pages.staffManagement.deactivate.confirm':
    'Are you sure you want to deactivate this staff member?',
  // Pending Invitations
  'pages.staffManagement.pending.title': 'Pending Invitations',
  'pages.staffManagement.pending.description':
    'Invitations that have been sent but not yet accepted. Expired invitations can be resent.',
  'pages.staffManagement.pending.email': 'Email',
  'pages.staffManagement.pending.role': 'Role',
  'pages.staffManagement.pending.sentAt': 'Sent At',
  'pages.staffManagement.pending.expiresAt': 'Expires At',
  'pages.staffManagement.pending.status': 'Status',
  'pages.staffManagement.pending.actions': 'Actions',
  'pages.staffManagement.pending.expired': 'Expired',
  'pages.staffManagement.pending.waiting': 'Waiting',
  'pages.staffManagement.pending.resend': 'Resend',
  'pages.staffManagement.pending.resendConfirm':
    'Are you sure you want to resend this invitation?',
  'pages.staffManagement.pending.resendSuccess': 'Invitation resent to {email}',
  'pages.staffManagement.pending.resendError': 'Failed to resend invitation',
  'pages.staffManagement.pending.resendNotExpired':
    'Can only resend expired invitations',
  'pages.staffManagement.pending.resendDisabledTip':
    'Can only resend expired invitations',

  // Partner Grants (cross-owner partner grants)
  'pages.partnerGrants.title': 'Partner Grants',
  'pages.partnerGrants.noAccess':
    'You do not have permission to access this page.',
  'pages.partnerGrants.grant.title': 'Grant Partners',
  'pages.partnerGrants.grant.description':
    'Grant another user access to some of your partners. Unregistered emails receive an invitation; access takes effect once accepted.',
  'pages.partnerGrants.grant.email': 'Email Address',
  'pages.partnerGrants.grant.emailPlaceholder':
    "Enter the target user's email address",
  'pages.partnerGrants.grant.emailRequired': 'Please enter an email address',
  'pages.partnerGrants.grant.emailInvalid':
    'Please enter a valid email address',
  'pages.partnerGrants.grant.partners': 'Partners',
  'pages.partnerGrants.grant.partnersPlaceholder':
    'Select the partners to grant',
  'pages.partnerGrants.grant.partnersRequired':
    'Please select at least one partner',
  'pages.partnerGrants.grant.role': 'Role',
  'pages.partnerGrants.grant.rolePlaceholder': 'Select a role',
  'pages.partnerGrants.grant.roleRequired': 'Please select a role',
  'pages.partnerGrants.grant.role.owner': 'Partner Owner',
  'pages.partnerGrants.grant.role.ownerDesc':
    'Full management access, but cannot invite staff or re-grant to others',
  'pages.partnerGrants.grant.role.viewer': 'Partner Viewer',
  'pages.partnerGrants.grant.role.viewerDesc':
    'Read-only access (enforced by the server)',
  'pages.partnerGrants.grant.submit': 'Grant Access',
  'pages.partnerGrants.grant.success': 'Partners granted to {email}',
  'pages.partnerGrants.grant.invited':
    '{email} is not registered yet — an invitation has been sent',
  'pages.partnerGrants.role.owner': 'Granted · Manage',
  'pages.partnerGrants.role.viewer': 'Granted · Read-only',
  'pages.partnerGrants.list.title': 'Granted Users',
  'pages.partnerGrants.table.name': 'Name',
  'pages.partnerGrants.table.email': 'Email',
  'pages.partnerGrants.table.grants': 'Granted Partners',
  'pages.partnerGrants.table.actions': 'Actions',
  'pages.partnerGrants.expanded.partner': 'Partner',
  'pages.partnerGrants.expanded.role': 'Role',
  'pages.partnerGrants.expanded.status': 'Status',
  'pages.partnerGrants.expanded.grantedAt': 'Granted At',
  'pages.partnerGrants.expanded.actions': 'Actions',
  'pages.partnerGrants.status.active': 'Active',
  'pages.partnerGrants.status.revoked': 'Revoked',
  'pages.partnerGrants.action.revoke': 'Revoke',
  'pages.partnerGrants.action.revokeAll': 'Revoke All',
  'pages.partnerGrants.revoke.confirm': 'Revoke the grant on this partner?',
  'pages.partnerGrants.revokeAll.confirm': "Revoke all of this user's grants?",
  'pages.partnerGrants.revoke.success': 'Grant revoked',
  'pages.partnerGrants.pending.title': 'Pending Grant Invitations',
  'pages.partnerGrants.pending.email': 'Email',
  'pages.partnerGrants.pending.role': 'Role',
  'pages.partnerGrants.pending.partners': 'Partners',
  'pages.partnerGrants.pending.sentAt': 'Sent At',
  'pages.partnerGrants.pending.status': 'Status',
  'pages.partnerGrants.pending.actions': 'Actions',
  'pages.partnerGrants.pending.expired': 'Expired',
  'pages.partnerGrants.pending.waiting': 'Waiting',
  'pages.partnerGrants.action.cancelInvitation': 'Cancel',
  'pages.partnerGrants.invitation.cancelConfirm': 'Cancel this invitation?',
  'pages.partnerGrants.invitation.cancelled': 'Invitation cancelled',
  'pages.merchantAccess.viewerRestricted':
    'Your role on this merchant is read-only and cannot access this page.',

  // Empty Merchants Component
  'components.emptyMerchants.title': 'No Merchant Selected',
  'components.emptyMerchants.description':
    'Please select a merchant from the dropdown or create a new one to get started.',
  'components.emptyMerchants.description.noPermission':
    'Please select a merchant from the dropdown. Merchants are created by the platform administrator — contact them to have one set up.',
  'components.emptyMerchants.createButton': 'Create Merchant',

  // Common
  'pages.common.loading': 'Loading...',
  'pages.common.error': 'An error occurred',
  'pages.common.retry': 'Retry',
  'pages.common.save': 'Save',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'Confirm',
  'pages.common.delete': 'Delete',
  'pages.common.search': 'Search',
  'pages.common.reset': 'Reset',
  'pages.common.export': 'Export',
  'pages.common.import': 'Import',
  'pages.common.refresh': 'Refresh',
  'pages.common.view': 'View',
  'pages.common.yes': 'Yes',
  'pages.common.no': 'No',
  'pages.common.done': 'Done',

  // Status
  'pages.status.active': 'Active',
  'pages.status.inactive': 'Inactive',
  'pages.status.linked': 'Linked',
  'pages.status.notCreated': 'Not Created',
  'pages.status.issues': 'Issues',

  // Currency
  'pages.currency.aud': 'AUD - Australian Dollar',
  'pages.currency.nzd': 'NZD - New Zealand Dollar',
  'pages.currency.selectPlaceholder': 'Select currency',
  'pages.currency.selectRequired': 'Please select currency',

  // Error States
  'pages.error.loadFailed': 'Failed to load customer',
  'pages.error.retryLater': 'Please try again later',
  'pages.error.notFound': 'Customer Not Found',
  'pages.error.notFoundDesc':
    "Customer with ID {id} does not exist or you don't have access to it.",
  'pages.error.noAccess': 'You do not have permission to access this page.',
  'pages.error.noBalanceAccounts':
    'No balance accounts available. Please create a balance account first.',

  // Partner Detail
  'pages.partners.detail.legalName': 'Legal Name',
  'pages.partners.detail.address': 'Registered Address',
  'pages.partners.detail.firstName': 'First Name',
  'pages.partners.detail.lastName': 'Last Name',
  'pages.partners.detail.type': 'Type',
  'pages.partners.detail.email': 'Email',
  'pages.partners.detail.adyenAccountHolder': 'Adyen Account Holder',
  'pages.partners.detail.balanceAccounts': 'Balance Accounts',
  'pages.partners.detail.adyenProfile': 'Adyen Profile',
  'pages.partners.detail.descriptionPlaceholder':
    'Enter description (optional)',
  'pages.partners.detail.verificationAlert.title': 'Verification Issues Found',
  'pages.partners.detail.verificationAlert.prompt':
    'Please continue the verification process to resolve these issues:',
  'pages.partners.detail.verificationAlert.unknownError':
    'Unknown verification issue',
  'pages.partners.detail.continueVerification': 'Continue Verification',

  // Business Lines
  'pages.businessLines.title': 'Business Lines',
  'pages.businessLines.empty':
    'No business lines configured. Setup Adyen to create one.',
  'pages.businessLines.id': 'Business Line ID',
  'pages.businessLines.service': 'Service',
  'pages.businessLines.industryCode': 'Industry Code',
  'pages.businessLines.salesChannels': 'Sales Channels',
  'pages.businessLines.website': 'Website',
  'pages.businessLines.create': 'Add Business Line',
  'pages.businessLines.createSuccess': 'Business line created successfully',
  'pages.businessLines.createError': 'Failed to create business line',
  'pages.businessLines.editTitle': 'Edit Business Line',
  'pages.businessLines.editSuccess': 'Business line updated successfully',
  'pages.businessLines.editError': 'Failed to update business line',
  'pages.businessLines.deleteConfirm':
    'Are you sure you want to delete this business line?',
  'pages.businessLines.deleteSuccess': 'Business line deleted successfully',
  'pages.businessLines.deleteError': 'Failed to delete business line',

  // Payment Methods
  'pages.paymentMethods.title': 'Payment Methods',
  'pages.paymentMethods.empty': 'No payment methods configured.',
  'pages.paymentMethods.add': 'Add Payment Method',
  'pages.paymentMethods.add.requiresStore': 'Create a store first',
  'pages.paymentMethods.createSuccess': 'Payment method created successfully',
  'pages.paymentMethods.createError': 'Failed to create payment method',
  'pages.paymentMethods.editTitle': 'Edit Payment Method',
  'pages.paymentMethods.editSuccess': 'Payment method updated successfully',
  'pages.paymentMethods.editError': 'Failed to update payment method',
  'pages.paymentMethods.disable': 'Disable',
  'pages.paymentMethods.disableConfirm':
    'Are you sure you want to disable this payment method?',
  'pages.paymentMethods.disableSuccess': 'Payment method disabled',
  'pages.paymentMethods.disableError': 'Failed to disable payment method',
  'pages.paymentMethods.type': 'Payment Type',
  'pages.paymentMethods.type.placeholder': 'Select payment type',
  'pages.paymentMethods.currencies': 'Currencies',
  'pages.paymentMethods.currencies.placeholder': 'Select currencies',
  'pages.paymentMethods.enabled': 'Enabled',
  'pages.paymentMethods.shopperInteraction': 'Shopper Interaction',
  'pages.paymentMethods.businessLine.placeholder': 'Select a business line',
  'pages.paymentMethods.stores': 'Stores',
  'pages.paymentMethods.stores.placeholder': 'Select stores',
  'pages.paymentMethods.applePay.domains.label': 'Apple Pay Web Domains',
  'pages.paymentMethods.applePay.domains.placeholder':
    'e.g. shop.example.com (press Enter to add)',
  'pages.paymentMethods.applePay.domains.tooltip':
    "The merchant's website domains (e.g. shop.example.com) where the Apple Pay button will appear. Each domain must host the Adyen-provided verification file at /.well-known/apple-developer-merchantid-domain-association — otherwise payments cannot be activated even if registration succeeds.",
  'pages.paymentMethods.applePay.domains.extra':
    'Missing or invalid domains will cause Adyen to return a 422 error. Do not enable Apple Pay for POS-only flows.',
  'pages.paymentMethods.applePay.domains.required':
    'Please provide at least one Apple Pay domain',
  'pages.paymentMethods.applePay.alert':
    'Before registering Apple Pay: (1) obtain the domain verification file from your Adyen Customer Area; (2) host it on each domain at /.well-known/apple-developer-merchantid-domain-association, reachable over HTTPS. Otherwise real payments will fail even though the API call succeeds.',
  'pages.paymentMethods.googlePay.merchantId.label': 'Google Pay Merchant ID',
  'pages.paymentMethods.googlePay.merchantId.placeholder':
    'e.g. BCR2DN6TSXXXZ000',
  'pages.paymentMethods.googlePay.merchantId.tooltip':
    'The Merchant ID obtained from Google Pay & Wallet Console (https://pay.google.com/business/console) after registration — visible in the top-right corner. Format: 16 uppercase alphanumeric characters or 20 numeric digits. Note: this is NOT the Adyen merchantAccount nor the Aimer store ID.',
  'pages.paymentMethods.googlePay.merchantId.extra':
    'Unregistered merchants should first register at https://pay.google.com/business/console and enable the Google Pay API.',
  'pages.paymentMethods.googlePay.merchantId.required':
    'Please provide the Google Pay Merchant ID',
  'pages.paymentMethods.googlePay.merchantId.invalid':
    'Invalid format: must be 16 uppercase alphanumeric characters or 20 numeric digits',
  'pages.paymentMethods.googlePay.reuseMerchantId.label': 'Reuse Merchant ID',
  'pages.paymentMethods.googlePay.reuseMerchantId.tooltip':
    'Enable this if the same Google Pay Merchant ID is already in use by other sub-merchants on this platform. Leave off in most cases.',
  'pages.paymentMethods.googlePay.alert':
    'Before registering Google Pay: (1) complete merchant registration at Google Pay & Wallet Console; (2) enable the Google Pay API; (3) obtain the Merchant ID from the top-right corner of the console.',
  'pages.paymentMethods.weChatPay.alert':
    'WeChat Pay requires a merchant support contact name and email. Your merchant account must be signed up for WeChat Pay with Adyen.',
  'pages.paymentMethods.weChatPay.contactPersonName.label':
    'Contact Person Name',
  'pages.paymentMethods.weChatPay.contactPersonName.required':
    'Contact person name is required',
  'pages.paymentMethods.weChatPay.contactPersonName.placeholder':
    'e.g. John Smith',
  'pages.paymentMethods.weChatPay.email.label': 'Support Email',
  'pages.paymentMethods.weChatPay.email.required': 'Support email is required',
  'pages.paymentMethods.weChatPay.email.invalid':
    'Please enter a valid email address',
  'pages.paymentMethods.weChatPay.email.placeholder':
    'e.g. support@example.com',
  'pages.paymentMethods.prefillTip':
    'Pre-filled from the store/merchant record — edit if needed.',
  // Alipay — one type ("alipay") covers both channels: eCommerce is Alipay,
  // pos is Alipay+. Adyen requires the channel to be set explicitly.
  'pages.paymentMethods.aliPay.alert':
    'Alipay uses one payment method type for two products: online (eCommerce) is Alipay, in-store (pos) is Alipay+. This store supports both channels, so pick the one to enable. Your merchant account must be signed up for Alipay with Adyen.',
  'pages.paymentMethods.aliPay.autoPos':
    "This store's business line is in-store (pos) only, so Alipay+ will be enabled.",
  'pages.paymentMethods.aliPay.autoEcommerce':
    "This store's business line is online (eCommerce) only, so Alipay will be enabled.",
  'pages.paymentMethods.aliPay.wapAlert':
    'Alipay (Mobile Web) is an online-only payment method — it will always be enabled for the eCommerce channel.',
  'pages.paymentMethods.aliPay.channel.label': 'Channel',
  'pages.paymentMethods.aliPay.channel.required': 'Please select a channel',
  'pages.paymentMethods.aliPay.channel.pos': 'Alipay+ (in-store / pos)',
  'pages.paymentMethods.aliPay.channel.ecommerce':
    'Alipay (online / eCommerce)',
  // EFTPOS Australia — AU stores only, settles in AUD. Adyen supports both channels,
  // but online EFTPOS requires a separate agreement, so the channel is picked here.
  'pages.paymentMethods.eftpos.alert':
    'EFTPOS Australia is available for Australian stores only and always settles in AUD (the currency selection above is ignored). Online EFTPOS requires a separate agreement with Adyen — if you only accept EFTPOS in store, keep the default. Enabling a channel your merchant account is not signed up for will make the whole request fail.',
  'pages.paymentMethods.eftpos.autoPos':
    "This store's business line is in-store (pos) only, so in-store EFTPOS will be enabled. It always settles in AUD (the currency selection above is ignored).",
  'pages.paymentMethods.eftpos.autoEcommerce':
    "This store's business line is online (eCommerce) only, so online EFTPOS will be enabled — this requires a separate agreement with Adyen. It always settles in AUD (the currency selection above is ignored).",
  'pages.paymentMethods.eftpos.channel.label': 'Channel',
  'pages.paymentMethods.eftpos.channel.required': 'Please select a channel',
  'pages.paymentMethods.eftpos.channel.pos': 'In-store EFTPOS (pos)',
  'pages.paymentMethods.eftpos.channel.ecommerce':
    'Online EFTPOS (eCommerce) — requires a separate agreement',
  'pages.paymentMethods.eftpos.channel.both': 'Both channels',
  // Payment method type labels (list column + type dropdown)
  'pages.paymentMethods.enabled.yes': 'Yes',
  'pages.paymentMethods.enabled.no': 'No',
  'pages.paymentMethods.type.visa': 'Visa',
  'pages.paymentMethods.type.mc': 'Mastercard',
  'pages.paymentMethods.type.amex': 'American Express',
  'pages.paymentMethods.type.diners': 'Diners',
  'pages.paymentMethods.type.cup': 'UnionPay (CUP)',
  'pages.paymentMethods.type.applepay': 'Apple Pay',
  'pages.paymentMethods.type.googlepay': 'Google Pay',
  'pages.paymentMethods.type.wechatpay': 'WeChat Pay',
  'pages.paymentMethods.type.wechatpay_pos': 'WeChat Pay (POS)',
  'pages.paymentMethods.type.alipay': 'Alipay',
  'pages.paymentMethods.type.alipay_wap': 'Alipay (Mobile Web)',
  'pages.paymentMethods.type.eftpos_australia': 'EFTPOS Australia',
  'pages.paymentMethods.alreadyRequested':
    "This payment method already exists (Adyen allows only one configuration per Store + BusinessLine + type). To change parameters: disable the existing one, wait for Adyen's 90-day automatic cleanup, then create a new one.",
  'pages.paymentMethods.applePay.editTip':
    'Apple Pay domains can be appended individually in the "Manage Domains" section below. ⚠️ Once added, an individual domain cannot be removed — to remove a domain, disable this PM and recreate.',
  'pages.paymentMethods.googlePay.editTip':
    'Google Pay merchantId cannot be modified after creation (Adyen limitation). To replace it: disable the current configuration; Adyen automatically deletes it after 90 days, after which you can re-create using the same Store + BusinessLine combination.',
  // Status column on PM list
  'pages.paymentMethods.status': 'Status',
  'pages.paymentMethods.reviewStatus': 'Review Status',
  'pages.paymentMethods.status.active': 'Active',
  'pages.paymentMethods.status.pending': 'Pending',
  'pages.paymentMethods.status.inactive': 'Inactive',
  // Apple Pay domains management (post-creation)
  'pages.paymentMethods.applePay.domains.manage': 'Manage Apple Pay Domains',
  'pages.paymentMethods.applePay.domains.current':
    'Currently registered domains',
  'pages.paymentMethods.applePay.domains.add': 'Add new domains',
  'pages.paymentMethods.applePay.domains.addPlaceholder':
    'Enter a domain and press Enter (multiple allowed)',
  'pages.paymentMethods.applePay.domains.addSuccess':
    'Domains added successfully',
  'pages.paymentMethods.applePay.domains.addError': 'Failed to add domains',
  'pages.paymentMethods.applePay.domains.appendOnlyTip':
    'This is append-only — registered domains cannot be removed individually. To remove a domain, disable the entire Apple Pay payment method and recreate.',
  'pages.paymentMethods.applePay.domains.empty': 'No domains registered yet',
  'pages.paymentMethods.applePay.domains.loadError':
    'Failed to load registered domains',
  // shopperInteraction explicit selection (merchant-level)
  'pages.paymentMethods.shopperInteraction.placeholder':
    'Select shopper interaction',
  'pages.paymentMethods.shopperInteraction.required':
    'Please select a shopper interaction',
  'pages.paymentMethods.shopperInteraction.ecommerce': 'Online (eCommerce)',
  'pages.paymentMethods.shopperInteraction.pos': 'In-store (pos)',
  'pages.paymentMethods.shopperInteraction.contAuth':
    'Continuous Authorization (contAuth)',
  'pages.paymentMethods.shopperInteraction.moto': 'Mail/Phone Order (moto)',

  // Terminals
  'pages.terminals.title': 'Terminals',
  'pages.terminals.onboard': 'Add Terminal',
  'pages.terminals.onboardTitle': 'Onboard Terminal',
  'pages.terminals.onboardSuccess': 'Terminal onboarded successfully',
  'pages.terminals.onboardError': 'Failed to onboard terminal',
  'pages.terminals.editTitle': 'Edit Terminal',
  'pages.terminals.editSuccess': 'Terminal updated successfully',
  'pages.terminals.editError': 'Failed to update terminal',
  'pages.terminals.reassignTitle': 'Reassign Terminal',
  'pages.terminals.reassignSuccess': 'Terminal reassigned successfully',
  'pages.terminals.reassignError': 'Failed to reassign terminal',
  'pages.terminals.deleteConfirm':
    'Are you sure you want to delete this terminal?',
  'pages.terminals.deleteSuccess': 'Terminal deleted successfully',
  'pages.terminals.deleteError': 'Failed to delete terminal',
  'pages.terminals.syncSuccess': 'Terminal synced successfully',
  'pages.terminals.syncError': 'Failed to sync terminal',
  'pages.terminals.empty':
    'No terminals. Click "Add Terminal" to onboard a new device.',
  'pages.terminals.requiresActive':
    'Partner must be Active to onboard terminals',
  'pages.terminals.showOffline': 'Show offline',
  'pages.terminals.offlineDisabled': 'Terminal is offline',
  'pages.terminals.column.name': 'Terminal Name',
  'pages.terminals.column.poiid': 'POIID',
  'pages.terminals.column.model': 'Model',
  'pages.terminals.column.store': 'Store',
  'pages.terminals.column.licenseKey': 'License Key',
  'pages.terminals.column.status': 'Status',
  'pages.terminals.status.Boarded': 'Boarded',
  'pages.terminals.status.Offline': 'Offline',
  'pages.terminals.status.Unassigned': 'Unassigned',
  'pages.terminals.status.Maintenance': 'Maintenance',
  'pages.terminals.form.otp': 'OTP Code',
  'pages.terminals.form.otp.placeholder':
    'Enter 6-digit OTP from terminal screen',
  'pages.terminals.form.otp.required': 'OTP is required',
  'pages.terminals.form.terminalName': 'Terminal Name',
  'pages.terminals.form.terminalName.placeholder': 'e.g. Checkout 1',
  'pages.terminals.form.store': 'Assign to Store',
  'pages.terminals.form.store.placeholder': 'Select store (optional)',
  'pages.terminals.form.terminalType': 'Terminal Type',
  'pages.terminals.form.licenseKey': 'License Key',
  'pages.terminals.form.licenseKey.placeholder':
    'Aimer POS license key (optional)',
  'pages.terminals.form.ipAddress': 'IP Address',
  'pages.terminals.form.ipAddress.placeholder': 'e.g. 192.168.1.100 (optional)',
  'pages.terminals.form.newStore': 'New Store',
  'pages.terminals.form.newStore.placeholder': 'Select new store',
  'pages.terminals.form.newStore.required': 'Please select a store',

  // ============ Surcharge ============
  'pages.surcharge.title.terminal': 'Surcharge Settings — {name}',
  'pages.surcharge.title.store': 'Surcharge Settings (Store) — {name}',
  'pages.surcharge.title.default': 'Surcharge Settings',
  'pages.surcharge.usingInherited': 'Using inherited company default',
  'pages.surcharge.storeLevelHint':
    '(Store-level — applies to all Tap to Pay devices in this store)',
  'pages.surcharge.noCustomConfig':
    'No custom surcharge config found (using inherited default)',
  'pages.surcharge.saveSuccess': 'Surcharge settings saved',
  'pages.surcharge.saveError': 'Failed to save surcharge settings',
  'pages.surcharge.resetConfirm': 'Reset surcharge to inherited default?',
  'pages.surcharge.resetSuccess': 'Surcharge reset to inherited default',
  'pages.surcharge.resetError': 'Failed to reset surcharge',
  'pages.surcharge.resetButton': 'Reset to Default',
  'pages.surcharge.askConfirmation': 'Ask Shopper Confirmation',
  'pages.surcharge.excludeGratuity': 'Exclude Tips from Surcharge',
  'pages.surcharge.rulesDivider': 'Surcharge Rules by Card Brand',
  'pages.surcharge.brand': 'Card Brand',
  'pages.surcharge.brand.placeholder': 'Select brand',
  'pages.surcharge.brand.required': 'Required',
  'pages.surcharge.source': 'Funding Source',
  'pages.surcharge.source.placeholder': 'All (default)',
  'pages.surcharge.commercial': 'Commercial Only',
  'pages.surcharge.currency': 'Currency',
  'pages.surcharge.percentage': '% (e.g. 2.0)',
  'pages.surcharge.amount': 'Fixed (cents)',
  'pages.surcharge.maxAmount': 'Max (cents)',
  'pages.surcharge.addCurrency': 'Add Currency',
  'pages.surcharge.addRule': 'Add Card Brand Rule',

  // ============ Payments App Instances ============
  'pages.paymentsApps.title': 'Payments App',
  'pages.paymentsApps.empty': 'No Payments App instances registered.',
  'pages.paymentsApps.revokeConfirm':
    'Revoke this Payments App instance? The device will need to re-board to process payments.',
  'pages.paymentsApps.revokeSuccess':
    'Payments App instance revoked successfully',
  'pages.paymentsApps.revokeError': 'Failed to revoke Payments App instance',
  'pages.paymentsApps.alreadyRevoked': 'Already revoked',
  'pages.paymentsApps.column.installationId': 'Installation ID',
  'pages.paymentsApps.column.status': 'Status',
  'pages.paymentsApps.column.merchantAccountCode': 'Merchant Account',
  'pages.paymentsApps.column.merchantStoreCode': 'Store Code',
  'pages.paymentsApps.status.ActiveForMaintenance': 'Active (Maintenance)',
  'pages.paymentsApps.status.ActiveForPayment': 'Active (Payment)',
  'pages.paymentsApps.status.PendingBoarding': 'Pending Boarding',
  'pages.paymentsApps.status.Revoked': 'Revoked',
  'pages.paymentsApps.status.BOARDED': 'Boarded',

  // ============ Transfer Instruments ============
  'pages.transferInstruments.title': 'Bank Accounts',
  'pages.transferInstruments.add': 'Add Bank Account',
  'pages.transferInstruments.accountNumber': 'Account Number',
  'pages.transferInstruments.bankName': 'Bank Name',
  'pages.transferInstruments.bankNamePlaceholder': 'e.g., ANZ, ASB, Westpac',
  'pages.transferInstruments.bsbCode': 'BSB Code',
  'pages.transferInstruments.onboardInfo':
    'You can add bank accounts through the Adyen onboarding page. Click the "Onboard" button above to get started.',
  'pages.transferInstruments.currency': 'Currency',
  'pages.transferInstruments.country': 'Country',
  'pages.transferInstruments.createSuccess': 'Bank account added successfully',
  'pages.transferInstruments.createError': 'Failed to add bank account',
  'pages.transferInstruments.deleteSuccess': 'Bank account deleted',
  'pages.transferInstruments.deleteError': 'Failed to delete bank account',
  'pages.transferInstruments.deleteConfirm':
    'Are you sure you want to delete this bank account?',
  'pages.transferInstruments.empty': 'No bank accounts',
  'pages.transferInstruments.detailTitle': 'Bank Account Details',
  'pages.transferInstruments.type': 'Type',
  'pages.transferInstruments.trustedSource': 'Trusted Source',
  'pages.transferInstruments.yes': 'Yes',
  'pages.transferInstruments.no': 'No',
  'pages.transferInstruments.capabilities': 'Capabilities',
  'pages.transferInstruments.allowed': 'Allowed',
  'pages.transferInstruments.notAllowed': 'Not Allowed',

  // ============ Sweeps ============
  'pages.sweeps.title': 'Automatic Payouts',
  'pages.sweeps.create': 'Create Payout Rule',
  'pages.sweeps.edit': 'Edit Payout Rule',
  'pages.sweeps.bankAccount': 'Bank Account',
  'pages.sweeps.transferTo': 'Transfer To',
  'pages.sweeps.schedule': 'Schedule',
  'pages.sweeps.scheduleDescription':
    "Daily automatic payout at 7:00 AM, using the balance account's time zone",
  'pages.sweeps.schedule.daily9am': 'Daily at 7:00 AM',
  'pages.sweeps.triggerAmount': 'Trigger Amount',
  'pages.sweeps.triggerAmountTip':
    'Payout is triggered when balance exceeds this amount',
  'pages.sweeps.targetAmount': 'Target Amount',
  'pages.sweeps.targetAmountTip': 'Amount to keep in the account after payout',
  'pages.sweeps.status': 'Status',
  'pages.sweeps.status.active': 'Active',
  'pages.sweeps.status.inactive': 'Inactive',
  'pages.sweeps.createSuccess': 'Payout rule created successfully',
  'pages.sweeps.createError': 'Failed to create payout rule',
  'pages.sweeps.updateSuccess': 'Payout rule updated successfully',
  'pages.sweeps.updateError': 'Failed to update payout rule',
  'pages.sweeps.deleteSuccess': 'Payout rule deleted',
  'pages.sweeps.deleteError': 'Failed to delete payout rule',
  'pages.sweeps.deleteConfirm':
    'Are you sure you want to delete this payout rule?',
  'pages.sweeps.statusUpdated': 'Payout rule status updated',
  'pages.sweeps.noBankAccount':
    'Please add a bank account first in the merchant detail page',
  'pages.sweeps.cronPreset': 'Schedule Preset',
  'pages.sweeps.cronExpression': 'Cron Expression',
  'pages.sweeps.cronExpression.tooltip':
    'Cron format: minute hour day month weekday (e.g., 0 7 * * * for daily at 7:00 AM)',
  'pages.sweeps.cronExpression.invalid': 'Please enter a valid cron expression',

  // Admin - Merchant Access Requests (SuperAdmin approval queue)
  'pages.admin.accessRequests.title': 'Merchant Access Requests',
  'pages.admin.accessRequests.requester': 'Requested By',
  'pages.admin.accessRequests.owner': 'Merchant Owner',
  'pages.admin.accessRequests.requestedAt': 'Requested At',
  'pages.admin.accessRequests.actions': 'Actions',
  'pages.admin.accessRequests.approve': 'Approve',
  'pages.admin.accessRequests.reject': 'Reject',
  'pages.admin.accessRequests.approveTitle': 'Approve Access Request',
  'pages.admin.accessRequests.rejectTitle': 'Reject Access Request',
  'pages.admin.accessRequests.durationLabel': 'Access duration',
  'pages.admin.accessRequests.duration.1h': '1 hour',
  'pages.admin.accessRequests.duration.4h': '4 hours',
  'pages.admin.accessRequests.duration.8h': '8 hours',
  'pages.admin.accessRequests.duration.1d': '1 day',
  'pages.admin.accessRequests.duration.3d': '3 days',
  'pages.admin.accessRequests.rejectReasonPlaceholder': 'Reason (optional)',
  'pages.admin.accessRequests.approveSuccess': 'Request approved',
  'pages.admin.accessRequests.rejectSuccess': 'Request rejected',
  'pages.admin.accessRequests.empty': 'No pending requests',

  // Admin - Split Configuration
  'pages.admin.splitConfig.title': 'Split Configuration Management',
  'pages.admin.splitConfig.tab.configs': 'Split Configs',
  'pages.admin.splitConfig.tab.storeAssignment': 'Store Assignment',
  'pages.admin.splitConfig.column.description': 'Description',
  'pages.admin.splitConfig.column.commissionRate': 'Commission Rate',
  'pages.admin.splitConfig.column.fixedFee': 'Fixed Fee',
  'pages.admin.splitConfig.column.configId': 'Config ID',
  'pages.admin.splitConfig.column.currentConfig': 'Current Config',
  'pages.admin.splitConfig.globalDefault': 'Global Default',
  'pages.admin.splitConfig.create': 'Create Config',
  'pages.admin.splitConfig.create.success':
    'Split configuration created successfully',
  'pages.admin.splitConfig.create.error':
    'Failed to create split configuration',
  'pages.admin.splitConfig.createModal.title': 'Create Split Configuration',
  'pages.admin.splitConfig.assign': 'Assign',
  'pages.admin.splitConfig.assign.success':
    'Split configuration assigned successfully',
  'pages.admin.splitConfig.assign.modalTitle':
    'Assign Split Configuration to {store}',
  'pages.admin.splitConfig.clear': 'Clear',
  'pages.admin.splitConfig.clear.confirm': 'Clear Split Configuration',
  'pages.admin.splitConfig.clear.confirmContent':
    'This will revert store "{name}" to the global default. Continue?',
  'pages.admin.splitConfig.clear.success':
    'Split configuration cleared. Store will use global default.',
  'pages.admin.splitConfig.form.description': 'Description',
  'pages.admin.splitConfig.form.commissionRate': 'Commission Rate (%)',
  'pages.admin.splitConfig.form.fixedFee': 'Fixed Fee ({currency})',
  'pages.admin.splitConfig.form.selectConfig': 'Split Configuration',
  'pages.admin.splitConfig.form.balanceAccountId': 'Adyen Balance Account ID',
  'pages.admin.splitConfig.partners': 'Customers',
  'pages.admin.splitConfig.stores': 'Stores',
  'pages.admin.splitConfig.selectPartner': 'Select a customer to view stores',
  'pages.admin.splitConfig.noPartners': 'No customers found',
  'pages.admin.splitConfig.noStores': 'No stores found for this customer',
  'pages.admin.splitConfig.profile.label': 'Adyen Profile',
  'pages.admin.splitConfig.profile.switchHint':
    'Switching profile reloads configurations for that merchant account.',
  'pages.admin.splitConfig.delete.disabledHint':
    'This is the default split configuration for this profile and cannot be deleted. Assign a different default first.',
  'pages.admin.splitConfig.tab.byConfig': 'Assignments by Config',
  'pages.admin.splitConfig.column.partner': 'Customer',
  'pages.admin.splitConfig.column.store': 'Store',
  'pages.admin.splitConfig.column.status': 'Status',
  'pages.admin.splitConfig.unassign': 'Unassign',
  'pages.admin.splitConfig.unknownConfig': 'Unknown config',
  'pages.admin.splitConfig.staleLabel': 'Unknown config (stale)',
  'pages.admin.splitConfig.explicitDefaultTooltip':
    'Explicitly set to the profile default',
  'pages.admin.splitConfig.searchStoresPlaceholder':
    'Search by store name, tag or customer',

  // Admin - Invitations
  'pages.admin.invitations.title': 'Platform User Invitations',
  'pages.admin.invitations.inviteTitle': 'Invite Platform User',
  'pages.admin.invitations.inviteDesc':
    'Send an invitation to add a platform user (SuperAdmin or Admin). The invitee will receive an email with a link to set up their account.',
  'pages.admin.invitations.emailPlaceholder': 'Enter email address',
  'pages.admin.invitations.pendingTitle': 'Pending Invitations',
  'pages.admin.invitations.noInvitations': 'No pending invitations',
  'pages.admin.invitations.pendingRole': 'Role',
  'pages.admin.invitations.success': 'Invitation sent successfully',
  'pages.admin.invitations.error': 'Failed to send invitation',
  'pages.admin.invitations.role.label': 'Role',
  'pages.admin.invitations.role.placeholder': 'Select a role to invite',
  'pages.admin.invitations.role.required': 'Please select a role',
  'pages.admin.invitations.role.superAdmin': 'Super Admin',
  'pages.admin.invitations.role.admin': 'Admin',

  // Merchant Owners page (SuperAdmin)
  'pages.merchantOwners.title': 'Merchant Owners',
  'pages.merchantOwners.name': 'Merchant Owner',
  'pages.merchantOwners.username': 'Username',
  'pages.merchantOwners.partnerCount': 'Merchants',
  'pages.merchantOwners.partners': 'Customer List',
  'pages.merchantOwners.enter': 'Enter',
  'pages.merchantOwners.searchPlaceholder':
    'Name / Email / Merchant / Store / Tag',

  // Common table
  'pages.table.titleOption': 'Actions',

  // Split config form
  'pages.admin.splitConfig.form.balanceAccountEmpty':
    'No balance accounts found for this partner',

  // Split config form - Rule Conditions
  'pages.admin.splitConfig.form.ruleConditions': 'Rule Conditions',
  'pages.admin.splitConfig.form.currency': 'Currency',
  'pages.admin.splitConfig.form.currency.tooltip':
    'Which currencies this rule applies to. ANY = all currencies.',
  'pages.admin.splitConfig.form.paymentMethod': 'Payment Method',
  'pages.admin.splitConfig.form.paymentMethod.tooltip':
    'Which payment methods this rule applies to. ANY = all payment methods.',
  'pages.admin.splitConfig.form.cardRegion': 'Card Region',
  'pages.admin.splitConfig.form.cardRegion.tooltip':
    'Matches based on card issuer vs store location. Domestic = same country; International = different countries. Pilot feature — contact Adyen to enable; otherwise creation will fail.',
  'pages.admin.splitConfig.column.conditions': 'Conditions',
  'pages.admin.splitConfig.column.conditions.catchAll': 'All (catch-all)',
  'pages.admin.splitConfig.form.fundingSource': 'Funding Source',
  'pages.admin.splitConfig.form.fundingSource.tooltip':
    'Which card types this rule applies to. ANY = all card types. Useful for differentiating credit vs debit pricing.',
  'pages.admin.splitConfig.form.shopperInteraction': 'Shopper Interaction',
  'pages.admin.splitConfig.form.shopperInteraction.tooltip':
    'Which sales channel this rule applies to. Ecommerce = online; POS = in-store; ContAuth = subscription/stored card.',

  // Split config form - Advanced Split Logic
  'pages.admin.splitConfig.form.advancedSettings':
    'Advanced Split Logic Settings',
  'pages.admin.splitConfig.form.paymentFee': 'Payment Fee',
  'pages.admin.splitConfig.form.paymentFee.tooltip':
    'Who bears the transaction processing fees. Platform = deducted from liable account; Merchant = deducted from merchant balance account.',
  'pages.admin.splitConfig.form.refund': 'Refund',
  'pages.admin.splitConfig.form.refund.tooltip':
    'How refund amounts are deducted. Split ratio = deducted proportionally from all parties (recommended). Platform/Merchant = deducted from one account.',
  'pages.admin.splitConfig.form.chargeback': 'Chargeback',
  'pages.admin.splitConfig.form.chargeback.tooltip':
    'How chargeback amounts are deducted. Platform = platform bears chargeback risk (default). Split ratio = deducted proportionally.',

  // Rule-level CRUD & shared actions
  'pages.admin.splitConfig.confirm': 'Yes',
  'pages.admin.splitConfig.cancel': 'No',
  'pages.admin.splitConfig.column.actions': 'Actions',
  'pages.admin.splitConfig.column.rules': 'rules',
  'pages.admin.splitConfig.delete': 'Delete Config',
  'pages.admin.splitConfig.delete.confirm':
    'Delete this entire split configuration?',
  'pages.admin.splitConfig.delete.description':
    'This will remove the configuration and all its rules. Stores using this config will revert to the global default.',
  'pages.admin.splitConfig.delete.success':
    'Split configuration deleted successfully',
  'pages.admin.splitConfig.delete.error':
    'Failed to delete split configuration',
  'pages.admin.splitConfig.rule.add': 'Add Rule',
  'pages.admin.splitConfig.rule.addModal.title': 'Add Rule',
  'pages.admin.splitConfig.rule.add.success': 'Rule added successfully',
  'pages.admin.splitConfig.rule.add.error': 'Failed to add rule',
  'pages.admin.splitConfig.rule.editConditions': 'Edit Conditions',
  'pages.admin.splitConfig.rule.conditionsModal.title': 'Edit Rule Conditions',
  'pages.admin.splitConfig.rule.conditions.success':
    'Rule conditions updated successfully',
  'pages.admin.splitConfig.rule.conditions.error':
    'Failed to update rule conditions',
  'pages.admin.splitConfig.rule.editFee': 'Edit Fee',
  'pages.admin.splitConfig.rule.feeModal.title': 'Edit Rule Fee',
  'pages.admin.splitConfig.rule.fee.success': 'Rule fee updated successfully',
  'pages.admin.splitConfig.rule.fee.error': 'Failed to update rule fee',
  'pages.admin.splitConfig.rule.delete': 'Delete Rule',
  'pages.admin.splitConfig.rule.delete.confirm': 'Delete this rule?',
  'pages.admin.splitConfig.rule.delete.success': 'Rule deleted successfully',
  'pages.admin.splitConfig.rule.delete.error': 'Failed to delete rule',
  'pages.admin.splitConfig.form.refundCostAllocation': 'Refund Cost Allocation',
  'pages.admin.splitConfig.form.chargebackCostAllocation':
    'Chargeback Cost Allocation',
  'pages.admin.splitConfig.form.remainder': 'Remainder',
  'pages.admin.splitConfig.form.balanceAccountPlaceholder':
    'Select a balance account',
  'pages.admin.splitConfig.form.balanceAccountRequired':
    'Please select a balance account',
  'pages.admin.splitConfig.noStores.tag': 'No stores match this tag',
  'pages.admin.splitConfig.stores.tagResults':
    'Tag search results for "{query}"',
  'pages.admin.splitConfig.stores.tagSearchPlaceholder':
    'Search stores by tag (e.g. newbyRoad)',

  // Live split-configuration binding viewer (per-store modal)
  'pages.admin.splitConfig.viewSplitConfig.action': 'View live binding',
  'pages.admin.splitConfig.viewSplitConfig.modalTitle':
    'Split Configuration — {store}',
  'pages.admin.splitConfig.viewSplitConfig.loadFailed':
    'Failed to load the live binding from Adyen. Please retry.',
  'pages.admin.splitConfig.viewSplitConfig.notBound': 'Not bound in Adyen',
  'pages.admin.splitConfig.viewSplitConfig.notBoundDetail':
    'This store has no split configuration in Adyen, so its transactions are NOT being split — funds never reach the customer balance account. Use Assign to bind one, or Unassign to re-bind the profile default.',
  'pages.admin.splitConfig.viewSplitConfig.usingDefault':
    'Bound to the profile default',
  'pages.admin.splitConfig.viewSplitConfig.usingOverride':
    'Bound to an explicit configuration',
  'pages.admin.splitConfig.viewSplitConfig.localDrift':
    'Local record differs from Adyen',
  'pages.admin.splitConfig.viewSplitConfig.localDriftDetail':
    'Sync the store to refresh the local record (purely informational — Adyen always wins).',
  'pages.admin.splitConfig.viewSplitConfig.adyenBinding':
    'Adyen binding (live)',
  'pages.admin.splitConfig.viewSplitConfig.adyenBa':
    'Adyen balance account (live)',
  'pages.admin.splitConfig.viewSplitConfig.profileDefault': 'Profile default',
  'pages.admin.splitConfig.viewSplitConfig.localRecord': 'Local record',

  // Advanced split-logic labels & tooltips
  'pages.admin.splitConfig.form.surcharge': 'Surcharge',
  'pages.admin.splitConfig.form.surcharge.tooltip':
    'Where to book surcharge amounts charged to the shopper.',
  'pages.admin.splitConfig.form.tip': 'Tip',
  'pages.admin.splitConfig.form.tip.tooltip':
    'Where to book tip (gratuity) amounts.',
  'pages.admin.splitConfig.form.refundCostAllocation.tooltip':
    'Who bears the refund processing costs.',
  'pages.admin.splitConfig.form.chargebackCostAllocation.tooltip':
    'Who bears the chargeback processing costs.',
  'pages.admin.splitConfig.form.remainder.tooltip':
    'Where to book the amount left over after currency conversion.',
  'pages.admin.splitConfig.form.notSet': 'Not set',
  'pages.admin.splitConfig.form.descriptionPlaceholder':
    'e.g. Platform commission: 5% + $0.30',
  'pages.admin.splitConfig.form.selectConfigPlaceholder':
    'Select a split configuration',

  // Nested rule table headers & shared actions
  'pages.admin.splitConfig.column.ruleId': 'Rule ID',
  'pages.admin.splitConfig.column.pm': 'PM',
  'pages.admin.splitConfig.column.channel': 'Channel',
  'pages.admin.splitConfig.column.currency': 'Currency',
  'pages.admin.splitConfig.column.funding': 'Funding',
  'pages.admin.splitConfig.column.region': 'Region',
  'pages.admin.splitConfig.action.cancel': 'Cancel',
  'pages.admin.splitConfig.action.copied': 'Copied!',
  'pages.admin.splitConfig.action.copyId': 'Copy ID',

  // Multi-rule create
  'pages.admin.splitConfig.create.ruleLabel': 'Rule {index}',
  'pages.admin.splitConfig.create.addRule': 'Add Another Rule',
  'pages.admin.splitConfig.create.removeRule': 'Remove',
};
